import { render } from "./PSperiod.vue?vue&type=template&id=5ed7547d&scoped=true"
import script from "./PSperiod.vue?vue&type=script&lang=js"
export * from "./PSperiod.vue?vue&type=script&lang=js"

import "./PSperiod.vue?vue&type=style&index=0&id=5ed7547d&lang=scss&scoped=true"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed7547d"]])

export default __exports__